import type { IBond } from "@/modules/bond/common/types";
import { Bonds } from "@/modules/bond/components";
import { PageHeader } from "@/shared/components";
import { Heading } from "@ab.uitools/ui-library/components/Heading";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const BondsPage = () => {
  const { t } = useTranslation();

  const [selectedBond, setSelectedBond] = useState<IBond | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <>
      <div className="full-width page-container">
        <PageHeader/>
        <div className="full-width flexbox justify-content--center h-fit-content page-body">
          <div className="widget-wrapper">
            <div className="full-width mb-20">
              <Heading size="xsmall" weight="bolder">
                {t("bonds.title")}
              </Heading>
            </div>
            <Bonds
              setIsOpen={setIsOpen}
              isDetailOpen={isOpen}
              selectedBond={selectedBond}
              setSelectedBond={setSelectedBond}
            />
          </div>
        </div>
      </div>
    </>
  );
};
